import {AttributeLink, AttributeSetup, NodeUpgrade} from '@acng/frontend-stargazer';
import {Watch} from '@acng/frontend-relativity';

import {ctxAmateur} from '../../amateurPool/context/amateur.js';
import {Actor} from '../../layout/context/list.js';
import {compile} from '../service/template.js';
import {getFallbackImageUrl} from 'acng/layout/service/fallback-image.js';
import {media} from 'acng/core/service/env.js';
import {getListOfAmateur} from '../service/http.js';
import {IS, OR, guard} from '@acng/frontend-rubicon';

/**
 * @group DOM Attribute
 */
export const FRIEND_LIST_OF_AMATEUR = 'friend-list-of-amateur';

AttributeSetup(FRIEND_LIST_OF_AMATEUR, (name) => {
  const watch = Watch(`[${name}]`, ctxAmateur);
  const broadcast = Actor();

  AttributeLink(name, (element) =>
    watch(element, (element, amateur) =>
      broadcast(
        element,
        async (offset) => (offset || !amateur ? [] : getListOfAmateur(element, amateur)),
        async (friend) => (element, linker) => {
          NodeUpgrade(linker, {
            name: friend.nickname,
            image: friend.image_uri ? `${media.user}/${friend.image_uri}` : getFallbackImageUrl(),
            age: (node) => {
              ASSERT: guard(node, OR(IS(Element), IS(Text)));

              if (!friend.age) {
                node.parentElement?.remove();
              } else {
                node.textContent = `${friend.age}`;
              }
            },
          });
        }
      )
    )
  );

  return compile;
});
